// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be73be55","453":"6cd13012","455":"ce565058","644":"46898584"}[chunkId] + ".chunk.js";
};